import { alpha, createTheme } from "@mui/material/styles";
import color from "./constants";
import dimensions from "./constants";

export const Colors = {
  ...color.color,
  cancel: '#6c757d',
};

export const Dimensions = {
  ...dimensions.dimensions,
};

const theme = createTheme({
  palette: {
    primary: {
      main: Colors.primary,
    },
    secondary: {
      main: Colors.secondary,
    },
    success: {
      main: Colors.success
    },
    warning: {
      main: Colors.warning
    },
    info: {
      main: Colors.info
    },
    danger: {
      main: Colors.danger
    },
    cancel: {
      main: '#6c757d',
      contrastText: '#ffffff'
    }
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        asterisk: {
          color: Colors.danger
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 2,
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          padding: '2px 12px',
        }
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: alpha(Colors.primary, 0.5)
          }
        }

      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          '&.MuiButton-cancel': {
            backgroundColor: '#6c757d',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#5a6268'
            }
          }
        }
      }
    }
  },

});

export default theme;
